// GE Portal

<template>
<div class="lms1030 container white curved">
  <div class="board mb-0">
    <Ul class="crumbs text-charcoal mb-2">
      <li><sym-link to="/">Home</sym-link></li>
      <li><span aria-current="page">Portal</span></li>
    </Ul>

    <div class="p-3 lams curved border-lightgray mb-2">
      <p class="page-title serif bold mb-0"><i class="fa fa-globe fa-lg ml-1 mr-2"></i>Geodetic Engineer Portal</p>
    </div>

    <div class="links lams-light curved border-lightgray mb-3">
      <div class="text-center">
        <div class="buttons d-block mb-2" fw-44 text-center shadow-soft justify-between>
          <button type="button" class="lg-1 warning" @click="go('lms2000')"><i class="fa fa-folder-o fa-lg"></i>Submit Survey</button>
          <button type="button" class="lg-1 warning" @click="go('lms2010')"><i class="fa fa-clone fa-lg"></i>My Surveys</button>
          <button type="button" class="lg-1 warning" @click="go('lms5040')"><i class="fa fa-download fa-lg"></i>My Downloads</button>
          <button type="button" class="lg-1 warning" @click="go('lms5000')"><i class="fa fa-search fa-lg"></i>Lot Search</button>
          <button type="button" class="lg-1 cond-text warning" @click="go('lms3300')"><i class="fa fa-question-circle fa-md"></i>Transaction Inquiry</button>
        </div>

        <div class="buttons d-block" fw-44 text-center shadow-soft justify-between>
          <button type="button" class="lg-1 info" @click="go('lms1900')"><i class="fa fa-edit fa-lg"></i>Edit Profile</button>
          <button type="button" class="lg-1 info" @click="isPasswordModalVisible=true"><i class="fa fa-key fa-lg"></i>Password</button>
          <button type="button" class="lg-1 info" @click="go('lms2020')"><i class="fa fa-drivers-license-o fa-lg"></i>Authentication</button>
        </div>

        <div class="d-flex justify-center">
          <div class="pos-relative fw-44 curved border-lightgray shadow-light">
            <input type="file" class="input-file" title="" accept=".jpg, .png" ref="inputfile" @input="onUploadPhoto">
            <button type="button" class="info w-100 lg-1 text-center curved-0">Upload Photo</button>
            <img :src="getImageUrl()" alt="..." class="photo d-block mx-auto my-2 fw-30 circle border-main">
          </div>
        </div>

      </div>

    </div>

    <!-- <button type="button" class="warning" @click="onSubmitSurvey">Submit Survey</button> -->

  </div>

  <sym-modal
    v-model="isPasswordModalVisible"
    size="md"
    :header="true"
    :customBody="true"
    :footer="false"
    :keyboard="false"
    :dismissible="true"
    title="● Change Password"
    v-if="isPasswordModalVisible"
    @show="onShowPasswordModal"
    headerClass="info"
    dismissButtonClass="danger"
  >

  <div class="board p-1 mb-0 w-100">
    <form id="lm1030" class="curved-bottom border-dark lams-light p-3" @submit.prevent>

      <sym-text plain align="bottom" v-model="sec.oldPassword" caption="Old Password" type="password"></sym-text>

      <sym-text plain align="bottom" v-model="sec.newPassword" caption="New Password" type="password"></sym-text>
      <sym-text plain align="bottom" v-model="sec.confirmPassword" caption="Confirm Password" type="password"></sym-text>

      <div class="buttons w-100 justify-end mt-3 mb-2" fw-26 shadow-soft mb-0>
        <button type="button" class="success justify-between border-main" @click="onSubmitPasswordModal()"><i class="fa fa-check mr-2"></i>Save</button>
        <button type="button" class="primary justify-between border-main mr-0" @click="isPasswordModalVisible=false"><i class="fa fa-arrow-left mr-2"></i>Back</button>
      </div>

    </form>
  </div>

  </sym-modal>

</div>
</template>

<script>

import {
  ajax,
  upload
} from '../../js/http';

import
  PageBase
from '../PageBase.vue';

export default {
  extends: PageBase,
  name: 'lms1030',

  data () {
    return {
      accountCode: '',
      tsPhoto: 0,
      imageUrl: '',

      sec: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },

      isPasswordModalVisible: false

    };
  },

  methods: {

    // API calls

    uploadPhoto () {
      const
        me = this,
        width = 200,
        quality = 75,
        files = me.$refs.inputfile.files;

      return upload('api/images/' + me.accountCode + '?width=' + width.toString() + '&quality=' + quality.toString(), files);
    },

    changePassword () {
      const
        me = this,
        options = me.core.getAjaxOptions('PUT');

      let q = 'oldPassword=' + me.sec.oldPassword + '&newPassword=' + me.sec.newPassword;
      return ajax('api/accounts/' + me.accountCode + '/password?' + q, options);
    },

    // event handlers

    onShowPasswordModal () {
      const sec = this.sec;

      sec.oldPassword = '';
      sec.newPassword = '';
      sec.confirmPassword = '';

      setTimeout(() => {
        this.setFocus('oldPassword');
      }, 200);
    },

    onSubmitPasswordModal () {
      const me = this;

      if (me.sec.newPassword !== me.sec.confirmPassword) {
        me.advice.fault('New and Confirm passwords must match.', { duration: 4 } )
        return;
      }

      if (!me.isValid(me.$options.name)) {
        me.advice.fault('Fill in the required fields (marked in red).', { duration: 4 } )
        return;
      }

      let wait = me.wait();

      me.changePassword().then(
        result => {
          me.stopWait(wait);
          if (result) {
            me.advice.success('Password changed.', { duration: 4 });
            me.isPasswordModalVisible = false;
          } else {
            me.advice.fault('Attempt to change password failed.<hr>Old Password is incorrect.', { duration: 4 });
            setTimeout(() => {
              this.setFocus('oldPassword');
            }, 200);
          }
        },
        fault => {
          me.stopWait(wait);
          me.showFault(fault)
        }
      )

    },

    onUploadPhoto () {
      const me = this;

      if (!me.$refs.inputfile.files.length) {
        return;
      }

      switch (me.$refs.inputfile.files[0].type) {
        case 'image/jpeg':
        case 'image/png':
          break;

        default:
          me.advice.fault('Selected file rejected.<hr>Valid file type: .jpg, .png', { duration: 4 });
          return;
      }

      let wait = me.wait();
      me.uploadPhoto()
        .then( result => {
          if (result) {
            return me.sym.userInfo.restore();
          }
          me.stopWait(wait);
        })
        .then ( success => {
          me.stopWait(wait);
          if (success) {
            me.imageUrl = me.sym.userInfo.imageUrl;
            me.tsPhoto = Date.now();
            me.advice.success('Photo uploaded.', { duration: 4 });
          }
        })
        .catch ( fault => {
          me.stopWait(wait);
          me.showFault(fault);
        });

    },

    // helpers

    getImageUrl () {
      return 'img/' + (this.imageUrl || 'anonymous.png') + '?ts=' + this.tsPhoto.toString();
    },

  },

  mounted () {
    const
      me = this,
      info = me.sym.userInfo;

    me.accountCode = info.accountCode;
    me.imageUrl = info.imageUrl;
    me.tsPhoto = Date.now();

    me.dataConfig.models.push('sec');

    me.setRequiredMode(
      'oldPassword',
      'newPassword',
      'confirmPassword'
    );

  }

}

</script>

<style scoped>

.cond-text {
  font-family: 'Roboto Condensed';
}


/* .lms1030 {
  min-height: calc(100vh - 90px - 2rem) ;
} */

.page-title {
  font-size: 1.5rem;
}

.input-file {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

.photo {
  object-fit: cover;
  height: 7.5rem !important;
  max-height: 7.5rem !important;
}

.links {
  padding: 1.5rem;
}

@media (max-width: 800px) {
  .links {
    padding: 1.25rem;
  }
}

/* @media (max-width: 576px) {
  .lms1030 {
    min-height: calc(100vh - 84px) ;
  }
} */

@media (max-width: 480px) {
  .links {
    padding: 1.125rem;
  }
}

@media (max-width: 320px) {
  .page-title {
    font-size: 1.25rem;
  }
}

</style>